import WelcomeCallRoute from "@/views/welcomeCall/WelcomeCallRoute";
import WelcomeCall from "@/views/welcomeCall/WelcomeCall";
import Question from "@/views/welcomeCall/Question.vue";
import GettingStart from "@/views/welcomeCall/GettingStart.vue";

export default {
  path: "/welcomeCall",
  component: WelcomeCallRoute,
  children: [
    {
      path: "",
      name: "WelcomeCall",
      component: WelcomeCall
    },
    {
      path: "question",
      name: "WelcomeCallQuestion",
      component: Question
    },
    {
      path: "gettingStart",
      name: "WelcomeCallGettingStart",
      component: GettingStart
    },
  ]
};



// WEBPACK FOOTER //
// ./src/router/welcomeCall/index.js